// extracted by css-extract-rspack-plugin
export default {"knit-page-wrapper":"knit-page-wrapper-LWl5VV","knitPageWrapper":"knit-page-wrapper-LWl5VV"};